import React, { useEffect } from 'react';
import data from '../data/bio'
import { useGlobalContext } from "../context/GlobalContext";

export const Bio = () => {
  const { setLightTheme } = useGlobalContext()

  useEffect(() => {
    setLightTheme(true)
  }, [])


  return (

    <div className="b-bio l-container">
      <div className="b-bio__text">
        <h5>Full stack software developer with a background in audio-visual production and graphic design.</h5>
        <div className="b-bio__content">
          {data.content.map((item) => (
            <div className="b-bio__content-item">
              {item.items.map((text) => (
                <p className="b-bio__text">{text}</p>
              ))}
            </div>
          ))}
        </div>
      </div>

      <div className="b-bio__container">
        <div className="b-bio__iframe-box">
          <iframe className="b-bio__iframe" src="https://player.vimeo.com/video/330837978?loop=1&title=0&byline=0&portrait=0" title="KozlowskaM teaser"
            frameborder="0" webkitallowfullscreen mozallowfullscreen allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>

    </div>
  )
};

